import type { Visit, TenantSummary } from '../../api/types';
import { fmt, dur } from '../../utils/format';

function esc(s?: string | null): string {
  const d = document.createElement('div');
  d.textContent = s || '';
  return d.innerHTML;
}

export function generateReport(v: Visit, tenant?: TenantSummary | null) {
  const d = dur(v.fechaCheckin, v.fechaCheckout);
  const fotos = v.fotos || [];
  const logoHtml = tenant?.logoUrl
    ? '<img src="' + tenant.logoUrl + '" alt="' + esc(tenant.nombre) + '" style="max-height:56px;max-width:220px;margin-bottom:8px;display:block"/>'
    : '';
  const html =
    '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Reporte</title><style>body{font-family:-apple-system,sans-serif;max-width:700px;margin:0 auto;padding:24px;color:#2C2C2A}h1{color:#0F6E56;font-size:20px}h2{font-size:15px;color:#5F5E5A;margin:20px 0 8px}table{width:100%;border-collapse:collapse}td{padding:6px 8px;border-bottom:1px solid #eee;font-size:14px}td:first-child{color:#5F5E5A;width:140px}.img{max-width:280px;border-radius:8px;margin:4px}@media print{.np{display:none}}</style></head><body>' +
    logoHtml +
    '<h1>Reporte de visita técnica</h1><p style="color:#5F5E5A;margin-top:0">' +
    fmt(new Date().toISOString()) +
    '</p><h2>Datos</h2><table><tr><td>Cliente</td><td><strong>' +
    esc(v.client?.nombre) +
    '</strong></td></tr><tr><td>Dirección</td><td>' +
    esc(v.client?.direccion) +
    '</td></tr><tr><td>Técnico</td><td>' +
    esc(v.tecnico?.nombre) +
    '</td></tr>' +
    (v.numeroTicket ? '<tr><td>Ticket</td><td>' + esc(v.numeroTicket) + '</td></tr>' : '') +
    '<tr><td>Tipo</td><td>' +
    esc(v.tipo === 'emergencia' ? 'Emergencia' : 'Programada') +
    '</td></tr><tr><td>Programada</td><td>' +
    fmt(v.fechaProgramada) +
    '</td></tr><tr><td>Check-in</td><td>' +
    fmt(v.fechaCheckin) +
    '</td></tr><tr><td>Check-out</td><td>' +
    fmt(v.fechaCheckout) +
    '</td></tr>' +
    (d !== null ? '<tr><td>Duración</td><td>' + d + ' min</td></tr>' : '') +
    '</table><h2>Trabajo</h2><p>' +
    esc(v.descripcionTrabajo || 'Sin descripción.') +
    '</p>' +
    (fotos.length
      ? '<h2>Fotos</h2>' +
        fotos
          .map(
            (f) =>
              '<p style="font-size:12px;color:#5F5E5A;margin:8px 0 2px">' +
              f.tipo +
              '</p><img class="img" src="' +
              f.url +
              '"/>'
          )
          .join('')
      : '') +
    (v.firmaUrl
      ? '<h2>Firma</h2><img class="img" src="' +
        v.firmaUrl +
        '"/><p style="font-size:13px;color:#5F5E5A">' +
        esc(v.firmaNombreCliente) +
        ' · ' +
        fmt(v.firmaFecha) +
        '</p>'
      : '') +
    '<br/><button class="np" onclick="window.print()" style="padding:10px 24px;background:#0F6E56;color:white;border:none;border-radius:8px;cursor:pointer">Imprimir / PDF</button></body></html>';
  const w = window.open('', '_blank');
  w!.document.write(html);
  w!.document.close();
}
